import React from 'react'
import {connect} from 'react-redux'
import NachweisDetailEdit from './NachweisDetailEdit'
import {useLocation} from 'react-router-dom'

function mapStateToProps(state) {
  return {
    nachweisId: null,
    permissions: state.authentication.permissions,
    nachweisTyp: state.authentication.ausbildungsnachweistyp,
    authorId: state.authentication.id,
    hasVersetzungsplan: state.wizardtemplate.moduleSettings.hasVersetzungsplan,
    ausbildungsberuf: state.authentication.ausbildungsberuf,
  }
}
function withNachweisNummer(Component) {
  return function NachweisDetailCreateContainer(props) {
    const nachweisNummer = useLocation().pathname.split('/').pop()
    return <Component {...props} nachweisNumber={Number(nachweisNummer)} />
  }
}
export default withNachweisNummer(connect(mapStateToProps)(NachweisDetailEdit))
